import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { RushModeEnum } from '@core/enums'
import { CardDetail } from '@core/interfaces'
import { DealCardModel, RushModeModel } from '@rush-shared/models'
import { RushGameService } from '@rush-shared/services'
import { ModeTagComponent } from '@shared/components'
import { CardTypeEnum } from '@shared/enums'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'app-cards-deal',
  standalone: true,
  imports: [SvgIconComponent, CommonModule, ModeTagComponent],
  templateUrl: './cards-deal.component.html',
  styleUrl: './cards-deal.component.sass',
})
export class CardsDealComponent implements OnInit {
  get dealCards(): DealCardModel {
    return this._rushGameService.cardsDeal
  }

  get dealCardsLength(): number {
    return Object.keys(this.dealCards).length
  }

  mode: RushModeModel
  modeLabels: {
    [mode: number]: RushModeModel
  } = {
    [RushModeEnum.DealClosed]: {
      mode: RushModeEnum.DealClosed,
      name: 'DEAL CLOSE',
      class: 'danger',
      viaColor: '#FC4E4E',
      toColor: '#C83A0D',
    },
    [RushModeEnum.DealOpen]: {
      mode: RushModeEnum.DealOpen,
      class: 'primary',
      name: 'DEAL OPEN',
      viaColor: '#55FF39',
      toColor: '#21A600',
    },
  }
  showModeTag = false
  isDealOpen = false

  constructor(public _rushGameService: RushGameService) {}

  ngOnInit(): void {
    this._rushGameService.mode$.observer.subscribe((mode) => {
      this.showModeTag = mode === RushModeEnum.DealClosed || mode === RushModeEnum.DealOpen
      this.mode = this.modeLabels[mode]
      this.isDealOpen = mode === RushModeEnum.DealOpen
    })
  }

  buildUrl(card?: CardDetail) {
    if (!card) {
      return ''
    }

    return `assets/cards/${card.cardType}/${card.number}-${card.cardType}.svg`
  }
}
